import React, { Component } from "react";
import ShopListPanel from './food_court_shop_list_panel/shop_list_panel';
import HallInfoPanel from './hall_info_panel/hall_info_panel';
import ShopListPanelWide from './food_court_shop_list_panel/shop_list_panel_wide';
import HallInfoPanelWide from './hall_info_panel/hall_info_panel_wide';
import connectionAlertLogo from '../assets/alertDisconnectLarge.png';
import {inject, observer} from 'mobx-react';
import Flexbox from 'flexbox-react';

const horizontalMainPage = {
    minWidth: "1920px",
    minHeight: "1080px",
    height: "100vh",
    fontFamily: 'GraphikRegular'
};


@inject('RootStore')
@observer
export default class FoodCourt extends Component {
  render() {
    let hallInfoPanel, shopInfoPanel = '';
    const is_reversed = this.props.RootStore.styleStore.currentStylesDict.reversed;
    const flexDirection = is_reversed ? 'row-reverse' : 'row';
    if(this.props.RootStore.hallStore.wideShopListHallPage) {
        hallInfoPanel = <HallInfoPanel/>;
        shopInfoPanel = <ShopListPanelWide/>;
    } else {
        hallInfoPanel = <HallInfoPanelWide/>;
        shopInfoPanel =  <ShopListPanel/>;
    }

    return (
      <Flexbox style={horizontalMainPage} flexDirection={flexDirection}>
          {hallInfoPanel}
          {shopInfoPanel}
          <Flexbox width="0%" height="0%">
              <img src={connectionAlertLogo} alt="" width="0%"/>
          </Flexbox>
      </Flexbox>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/food_court_home_page.jsx